import { UseMutateAsyncFunction, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { useEditUserMutation } from 'api';
import { API_HANDLERS } from 'api/apiHandlers';
// import { useActivateToken } from 'api/queries/useActivateToken';
import { LoginRequestParams, LoginResponse } from 'api/types';
import { ENGLISH, SWEDISH } from 'features/languageSelector/components/LanguageSelector/constants';
import { useAuth, useSessionState, useSubscription } from 'hooks';
import { Language } from 'types';

interface UseLoginMutationReturn {
  loginMutation: UseMutateAsyncFunction<
    AxiosResponse<LoginResponse, unknown>,
    unknown,
    LoginRequestParams,
    unknown
  >;
  isLoading: boolean;
}

export function useLoginMutation(): UseLoginMutationReturn {
  const { saveUser } = useAuth();
  const { addNotification, addMockDataBanner } = useSubscription();
  const { editUserMutation } = useEditUserMutation();
  const language: Language | unknown = useSessionState('i18nextLng')[0];

  const LANG_CONFIG = language && language === Language.english ? ENGLISH : SWEDISH;

  const { mutateAsync: loginMutation, isLoading } = useMutation(API_HANDLERS.AUTH.LOGIN, {
    onSuccess: async (data) => {
      const { token, user } = data.data;

      localStorage.setItem('accessToken', token.access_token);
      localStorage.setItem('refreshToken', token.refresh_token);
      localStorage.setItem('expiresAt', String(token.expires_at));

      saveUser({ user });

      addNotification();
      addMockDataBanner();

      if (user?.lang !== LANG_CONFIG.value) {
        await editUserMutation({ id: user.id, user: { lang: LANG_CONFIG.value } });

        window.location.reload();
      }
    },
  });

  return {
    loginMutation,
    isLoading,
  };
}
